'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, '__esModule', {
  value: true
});
var textEncoder = new TextEncoder();
var maxInt32 = Math.pow(2, 32);
var maxUInt32 = Math.pow(2, 31);

function encodeLink(link, bytes) {
  var i = bytes.length;

  if (typeof link.Tsize === 'number') {
    if (link.Tsize < 0) {
      throw new Error('Tsize cannot be negative');
    }

    if (!Number.isSafeInteger(link.Tsize)) {
      throw new Error('Tsize too large for encoding');
    }

    i = encodeVarint(bytes, i, link.Tsize) - 1;
    bytes[i] = 24;
  }

  if (typeof link.Name === 'string') {
    var nameBytes = textEncoder.encode(link.Name);
    i -= nameBytes.length;
    bytes.set(nameBytes, i);
    i = encodeVarint(bytes, i, nameBytes.length) - 1;
    bytes[i] = 18;
  }

  if (link.Hash) {
    i -= link.Hash.length;
    bytes.set(link.Hash, i);
    i = encodeVarint(bytes, i, link.Hash.length) - 1;
    bytes[i] = 10;
  }

  return bytes.length - i;
}

function encodeNode(node) {
  var size = sizeNode(node);
  var bytes = new Uint8Array(size);
  var i = size;

  if (node.Data) {
    i -= node.Data.length;
    bytes.set(node.Data, i);
    i = encodeVarint(bytes, i, node.Data.length) - 1;
    bytes[i] = 10;
  }

  if (node.Links) {
    for (var index = node.Links.length - 1; index >= 0; index--) {
      var _size = encodeLink(node.Links[index], bytes.subarray(0, i));

      i -= _size;
      i = encodeVarint(bytes, i, _size) - 1;
      bytes[i] = 18;
    }
  }

  return bytes;
}

function sizeLink(link) {
  var n = 0;

  if (link.Hash) {
    var l = link.Hash.length;
    n += 1 + l + sov(l);
  }

  if (typeof link.Name === 'string') {
    var _l = textEncoder.encode(link.Name).length;
    n += 1 + _l + sov(_l);
  }

  if (typeof link.Tsize === 'number') {
    n += 1 + sov(link.Tsize);
  }

  return n;
}

function sizeNode(node) {
  var n = 0;

  if (node.Data) {
    var l = node.Data.length;
    n += 1 + l + sov(l);
  }

  if (node.Links) {
    var _iterator = _createForOfIteratorHelper(node.Links),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var link = _step.value;

        var _l2 = sizeLink(link);

        n += 1 + _l2 + sov(_l2);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return n;
}

function encodeVarint(bytes, offset, v) {
  offset -= sov(v);
  var base = offset;

  while (v >= maxUInt32) {
    bytes[offset++] = v & 127 | 128;
    v /= 128;
  }

  while (v >= 128) {
    bytes[offset++] = v & 127 | 128;
    v >>>= 7;
  }

  bytes[offset] = v;
  return base;
}

function sov(x) {
  if (x % 2 === 0) {
    x++;
  }

  return Math.floor((len64(x) + 6) / 7);
}

function len64(x) {
  var n = 0;

  if (x >= maxInt32) {
    x = Math.floor(x / maxInt32);
    n = 32;
  }

  if (x >= 1 << 16) {
    x >>>= 16;
    n += 16;
  }

  if (x >= 1 << 8) {
    x >>>= 8;
    n += 8;
  }

  return n + len8tab[x];
}

var len8tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8];
exports.encodeNode = encodeNode;